<template>
    <div id="hqmh">
        <headTop :id="id" @topback="topback"></headTop>
        <div class="banner" id="index">
            <img src="../../../static/images/zhtsgbjt.png" alt="" style="width: 100%;">
        </div>
        <detailBread :breadName="'艾思迈读者教育系统'" ></detailBread>
        <div class="container">
            <div class="page-title">
                艾思迈读者教育系统
            </div>
            <div class="page-content">
                <img src="../../../static/images/lres1.png" width="80%"/>
                <img src="../../../static/images/lres2.png" width="80%"/>
                <img src="../../../static/images/lres3.png" width="80%"/>
                <img src="../../../static/images/lres4.png" width="80%"/>
                <img src="../../../static/images/lres5.png" width="80%"/>
                <img src="../../../static/images/lres6.png" width="80%"/>
                <img src="../../../static/images/lres7.png" width="80%"/>
                <img src="../../../static/images/lres8.png" width="80%"/>
                <img src="../../../static/images/lres9.png" width="80%"/>
                <img src="../../../static/images/lres10.png" width="80%"/>
            </div>
        </div>
    </div>
</template>
<script>
import headTop from '@/components/headTop'
import detailTop from '@/components/detailTop'
import detailBread from '@/components/detailBread'
export default {
    metaInfo: {
        title: '读者教育', // set a title
        meta: [{             // set meta
            name: 'keyWords',
            content: '读者教育,新生入馆教育,图书馆考试系统'
        },
        {
            name: 'description',
            content: '读者教育,新生入馆教育,图书馆考试系统'
        }],
    },
    components:{
        detailTop,
        detailBread,
        headTop
    },
    data() {
        return {
            id:'2',
            blackTabsNum:'4'
        }
    },
    methods: {
        topback(){
            window.localStorage.setItem('blackTabsNum',4)
            this.$router.push({
                path:'/',
            })
        }
    },
    mounted() {
        $('html,body').animate({
            scrollTop: 0 + "px"
        }, {
            duration: 0,
            easing: "swing"
        });
        return false;
    },
    
}
</script>
<style scoped>
</style>


// WEBPACK FOOTER //
// src/pages/old/dzjy.vue